<template>
	<div class="page-new-s-organizational">
		<v-layout row>
			<v-flex xs1 v-if="visibleArrow">
				<v-layout align-end pb-4 class="h-100">
					<button
						class="btn-down d-flex-center"
						:style="`background-color:${$appColors.success}`"
						@click="scrollMore"
					>
						<img
							src="/static/img/factor/arrow-down.svg"
							alt="down"
							height="20px"
						/>
					</button>
				</v-layout>
			</v-flex>
			<v-flex xs6>
				<tabs :items="items"/>
				<v-layout my-3>
					<button class="button-confirm-pass" @click="selectAll">
						<v-icon
							class="icon-confirm-pass"
							color="success"
							:disabled="!checkAll"
						>
							check_circle
						</v-icon>
					</button>
					<v-flex xs4>
						<span
							class="text-confirm-pass"
							:style="`color:${$appColors.info}`"
						>
							Seleccionar todo
						</span>
					</v-flex>
				</v-layout>
				<v-layout row wrap class="wrapper-factors">
					<v-flex xs4
						v-for="(factor,index) in factors"
						:key="index"
					>
						<factor
							:item="factor"
							@select="selectFactor($event, index)"
						/>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs6 pl-4>
				<question
					:rotatedCard="!itemSelect"
					:title="title"
					:subTitle="subTitle"
				>
					<div
						slot="question"
						class="h-100"
					>
						<div v-if="!itemSelect">
							<div
								v-html="presentationText"
								class="text-presentation"
								:style="`color:${$appColors.info}`"
							></div>
						</div>
						<div v-else class="question-wrapper-big h-100">
							<div>
								<v-layout
									class="question-wrapper"
									v-for="(question, index) in itemSelect.entities"
									:key="question.id"
								>
									<v-flex xs1 align-self-center class="question-number center"
										:style="`color:${$appColors.primary}`"
									>
										{{index + 1}}.
									</v-flex>
									<v-flex xs11 class="question-text"
										:style="`color:${$appColors.info}`"
									>
										{{question.name}}
									</v-flex>
								</v-layout>
							</div>
						</div>
					</div>
					<v-btn
						class="btn btn-action"
						slot="footer"
						:disabled="!(dataSelected.length >= numberSelect)"
						@click.stop="openNewSurvey"
						color="primary"
					>
						Crear Encuesta
					</v-btn>
				</question>
			</v-flex>
		</v-layout>
		<open-modal
			:dialog="dialog"
			:footer="false"
			@close-modal="closeModal"
		>
			<v-layout justify-space-between>
				<v-flex xs8 class="message-error-container">
					<label class="new-survey-label">
						Nombre de la Encuesta
					</label>
					<input
						class="new-survey-input"
						placeholder="Nombre de la Encuesta"
						:style="`color: ${$appColors.info} !important`"
						v-model="nameSuvery"
					/>
					<span
						v-if="!nameSuvery"
						class="message-error"
						:style="`color:${$appColors.error}`"
					>
						El nombre es requerido
					</span>
				</v-flex>
				<v-flex xs2 pt-4>
					<v-btn
						class="btn btn-action btn-disabled-background"
						@click="goToList"
						:disabled="!(this.nameSuvery.trim() !== '')"
						color="primary"
					>
						Finalizar
					</v-btn>
					<br>
					<br>
				</v-flex>
			</v-layout>
		</open-modal>
	</div>
</template>
<script>
import tabs from '@/components/surveys/tabs';
import factor from '@/components/organizational/factor';
import openModal from '@/components/configuration/open-modal';
import question from '@/components/organizational/question';
import toolsCode from '@/shared/tools-codes';

function data() {
	return {
		items: [
			{
				number: 1,
				name: 'Escoge tus factores',
				step: 1,
				complete: false,
				page: 'new-organizational-diagnosis',
			},
		],
		factors: [],
		presentationText: ` <p>
								El DIAGNÓSTICO ORGANIZACIONAL del software PRAKTIKO facilita y acelera el proceso analítico y la comprensión de la situación actual de la organización porque permite identificar los recursos disponibles o faltantes para tomar decisiones.
							</p>
							<p>
								El Diagnóstico Organizacional de PRAKTIKO se aplica con el fin de recabar datos y opiniones de los participantes (en grupos por áreas) a efecto de diagnosticar a la organización en 14 factores esenciales para tener organizaciones ágiles, resilientes y tendientes a la excelencia.
							</p>
							<p>
								La claridad del DIAGNÓSTICO ORGANIZACIONAL obtenido luego de la aplicación es de alta utilidad en planificación, gestión y desarrollo organizacional ya que permite tomar acción para aprovechar las oportunidades identificadas y resolver los problemas detectados.
							</p>
							<p>
								Los resultados se obtienen a partir del diagnóstico cuantitativo de los siguientes factores, basados en premios a la Calidad como el Malcolm Baldrige, el EFQM y otros; por lo cual es una herramienta esencial para gestionar la calidad organizacional:
							</p>
							<ol>
								<li> Sistema de calidad</li>
								<li>Seguridad y salud ocupacional</li>
								<li>Sistemas de información</li>
								<li>Departamento Legal</li>
								<li>Control de calidad</li>
								<li>Mantenimiento</li>
								<li>Diseño del proceso, del productos y métodos de trabajo</li>
								<li>Proveedores y compras</li>
								<li>Distribución de planta, almacenamiento y manejo de materiales</li>
								<li>Planificación y control, de producción</li>
								<li>Recursos financieros</li>
								<li>Recursos Humanos</li>
								<li>Mercadeo y ventas</li>
								<li>Administración</li>
							</ol>
							<p>Se recomienda organizar grupos de calificación por áreas para llenarla.	</p>
							<p>La Herramienta DIAGNÓSTICO ORGANIZACIONAL de PRAKTIKO está diseñada para recabar la opinión por grupos del personal administrativo, técnico y directivo; al responder se debe llenar conforme se solicita en las preguntas o ítems. Las respuestas se deben elegir con un clic en niveles del 10 al 1; siendo 10 cuando se ha mejorado, se tiene debidamente documentado y siempre se hace lo que pide cada ítem. En 1 se califica exactamente lo contrario y se pueden elegir niveles intermedios por cada ítem. El sistema recopila la calificación promedio porcentual de las respuestas dadas por las personas asignadas en los grupos formados.</p>
							<p>El nivel de precisión de la información requiere formar grupos por áreas y con personas (3 a 7) que conozcan a la organización en ese ámbito; además exige un nivel de comprensión lectora medio, se recomienda aplicar a personal con nivel de instrucción bachiller o más.</p>
							<p>La interpretación se obtiene automáticamente en pantalla, conforme la calificación integrada.</p>
							<p>Si necesitas más información puedes recurrir a tutoriales de nuestra web: praktiko.tech, en la pestaña “Comunidad” PRAKTIKO subpestaña “Entrenamiento” o escribir un email a: info@praktiko.tech </p>
							`,
		dataSelected: [],
		itemSelect: null,
		numberSelect: 1,
		dialog: false,
		nameSuvery: '',
		title: 'DIAGNÓSTICO ORGANIZACIONAL PRAKTIKO',
		subTitle: 'INSTRUCTIVO',
		isLoading: false,
		checkAll: false,
		visibleArrow: false,
	};
}

function selectFactor(item, index) {
	this.factors[index].isSelected = !item.isSelected;
	this.checkAll = this.factors.every(f => f.isSelected);
	if (!item.isSelected) {
		this.deleteFactor(item);
		this.title = 'DIAGNOSTICO ORGANIZACIONAL PRAKTIKO';
		this.subTitle = 'INSTRUCTIVO';
	} else {
		this.itemSelect = { ...item };
		this.title = this.itemSelect.name;
		this.subTitle = 'PREGUNTAS';
		this.dataSelected.push(item);
	}
}

function deleteFactor(item) {
	const indexDelete = this.dataSelected.findIndex(f => f.id === item.id);
	if (indexDelete > -1) {
		this.dataSelected.splice(indexDelete, 1);
		this.itemSelect = null;
	}
}

function openNewSurvey() {
	this.dialog = true;
}

async function goToList() {
	const arrayQuestion = this.dataSelected.map((d) => {
		const newRow = {
			id: d.id,
			name: d.name,
			totalQuestions: d.entities.length,
			questions: d.entities.map(q => q.id),
		};
		return newRow;
	});
	const body = {
		name: this.nameSuvery,
		toolCode: toolsCode.OrgaDiagnosis,
		languages: null,
		factorsWeight: arrayQuestion,
	};
	try {
		const { data: poll } = await this.$http.post('polls', body);
		const params = { toolCode: toolsCode.OrgaDiagnosis, pollId: poll.id };
		this.goTo('new-diagnosis', { params });
	} catch (error) {
		this.showGenericError();
	}
}

function created() {
	this.loadData();
}

async function loadData() {
	const params = {
		flagAll: 1,
	};
	try {
		const { data: response } = await this.$http.get(
			`hierarchies/${toolsCode.OrgaDiagnosis}`, { params });
		this.factors = response.map((r) => {
			const newRow = { ...r };
			newRow.isSelected = false;
			newRow.questions = [];
			return newRow;
		});
		this.$nextTick(() => {
			const heightDiv = document.getElementsByClassName('wrapper-factors')[0].clientHeight;
			const heightScreen = screen.height;
			this.visibleArrow = heightScreen > heightDiv - 300;
		});
	} catch (error) {
		this.showGenericError();
	}
}

function selectAll() {
	this.checkAll = !this.checkAll;
	this.factors = this.factors.map((f) => {
		const newRow = { ...f };
		newRow.isSelected = this.checkAll;
		return newRow;
	});
	this.dataSelected = this.checkAll ? [...this.factors] : [];
	this.itemSelect = null;
}

function scrollMore() {
	document.getElementsByClassName('wrapper-factors')[0].scrollTop += 40;
}

function closeModal(val) {
	this.dialog = val;
}

export default {
	name: 'new-surveys',
	components: {
		openModal,
		tabs,
		factor,
		question,
	},
	created,
	methods: {
		closeModal,
		selectFactor,
		deleteFactor,
		openNewSurvey,
		goToList,
		loadData,
		selectAll,
		scrollMore,
	},
	data,
};
</script>
<style lang="scss">
	.page-new-s-organizational {
		position: relative;
	@media (max-width: 950px) {
			width: 750px;
		}
		.v-stepper__header {
			justify-content: center;
		}

		.surveys-tabs {
			width: 100%;
		}

		.wrapper-factors {
			max-height: calc(100vh - 274px);
			overflow-y: auto;
		}

		.text-presentation {
			font-size: 12px;
			padding: 24px 68px;
			text-align: justify;
		}

		.question-number {
			font-size: 12px;
		}

		.question-text {
			font-size: 12px;
		}

		.question-wrapper {
			border-bottom: 1px solid map-get($colors, gray-slider);
			padding: 10px 50px 10px 10px;
		}

		.question-wrapper-big {
			height: 100%;
			overflow-y: auto;
		}

		.h-100 {
			height: 100%;
		}

		.d-flex-center {
			align-items: center;
			display: flex;
			justify-content: center;
		}

		.btn-down {
			border-radius: 50%;
			height: 36px;
			width: 36px;
		}
	}

	.theme--light.v-icon.v-icon--disabled.icon-confirm-pass {
		color: #ababab !important;
		opacity: 1 !important;
	}

	.icon-confirm-pass {
		font-size: 22px !important;
	}

	.text-confirm-pass {
		font-family: font(regular);
		font-size: size(small11);
	}

	.button-confirm-pass {
		height: 22px;
		padding-right: 12px;
	}

	.new-survey-label {
		color: color(tooltip-gray);
	}

	.message-error-container {
		position: relative;
	}

	.message-error {
		bottom: -15px;
		font-family: font(regular);
		font-size: size(small11);
		position: absolute;
		width: 100%;
	}
</style>





// WEBPACK FOOTER //
// src/pages/organizational/page-new-surveys.vue